import {
  BoardIds,
  FilterIdentifier,
  FilterUserSelection,
} from "../../common/generic/generic-filters-boards-attributes";
import { BuildUrlForHyperlinkInGrid } from "../../common/generic/generic-helper";
import { SCAttributes } from "../../common/generic/generic-sc-attributes";
import {
  IGenericAggregateResponse,
  IGenericHyperlinkFilter,
} from "../../common/generic/generic-types";
import { SCProfileDictionary } from "../../common/salescredit/salescredit-profile-dictionary";
import { Functions } from "../../common/utils/clientlistHelper";
import { Format } from "../../common/utils/format";
export function getMapping(
  data: IGenericAggregateResponse,
  profile: string,
  attributes: string[],
  kpis: string[]
): any[] {
  const profileDictionary = new SCProfileDictionary();
  if (!data.aggregates || data.aggregates.length === 0) {
    return [];
  }
  const rows: any[] = [];
  const dateForFilter = [];
  if (data.request) {
    dateForFilter.push(data.request.date);
  }

  for (const item of data.aggregates) {
    const row: { [field: string]: string | number } = {};

    if (
      attributes.indexOf(SCAttributes.SC_CLIENT_LEID) > -1 ||
      attributes.indexOf(SCAttributes.SC_CLIENT_LENAME) > -1
    ) {
      const clientId =
        item.dimensionAttributeValues[SCAttributes.SC_CLIENT_LEID];
      const clientIdForFilter = [];

      clientIdForFilter.push(clientId);
      const hFilterTypes: any = [];
      hFilterTypes.push({
        filter_id: FilterIdentifier.client_selector,
        id: FilterUserSelection.client_selector,
        value: clientIdForFilter,
      });
      hFilterTypes.push({
        filter_id: FilterIdentifier.asOfDate,
        id: FilterUserSelection.asOfDate,
        value: dateForFilter,
      });
      const hFilter: IGenericHyperlinkFilter = {
        board_id: BoardIds.Client_Snapshot,
        filter: hFilterTypes,
      };

      row.hlink = BuildUrlForHyperlinkInGrid(hFilter);
    }
    for (const attributeRaw of attributes) {
      row[attributeRaw] = CheckNull(
        item.dimensionAttributeValues[attributeRaw]
      );
    }

    for (const kpiRaw of kpis) {
      row[kpiRaw] = CheckKpiForMtdVar(
        kpiRaw,
        item.indicatorKpiValues[profileDictionary.GetKpi(profile, kpiRaw)]
      );
    }
    const scYtdVarYoy = "sc_ytd_var_yoy";
    row[scYtdVarYoy] = Functions.calculateVariation(
      item.indicatorKpiValues.sc_ytd,
      item.indicatorKpiValues.sc_ytd_1
    );
    rows.push(row);
  }
  return rows;
}

function CheckNull(value: string): string {
  return value === "Null" ? "--" : value;
}

function CheckKpiForMtdVar(kpiRaw: string, value: number): number {
  return kpiRaw !== "sc_mtd_yoy"
    ? Functions.formatMoney(value)
    : isNaN(value)
    ? 0
    : value;
}
